import { ErpDiv, ErpSpan } from './ErpHtml';
import React from 'react';
import classNames from 'classnames';

export interface DetailItem {
  /** Optional stable identity; falls back to `label` (labels need not be unique). */
  id?: string;
  label: string;
  /** Plain text or a rich node (e.g. `<MaskedAmount />` for sensitive amounts). */
  value?: React.ReactNode;
  mono?: boolean;
  span?: 'full' | 'half';
}

interface Props {
  items?: DetailItem[];
  compact?: boolean;
  renderValue?: (item: DetailItem) => React.ReactNode;
}

const _DetailGrid: React.FC<Props> = ({ items = [], compact = false, renderValue }) => {
  return (
    <ErpDiv className={classNames('grid min-w-0 grid-cols-[repeat(auto-fit,minmax(min(100%,12rem),1fr))]', compact ? 'gap-x-3 gap-y-2' : 'gap-x-4 gap-y-3')}>
      {items.map((item, index) => (
        <ErpDiv
          key={item.id ?? `${item.label}-${index}`}
          className={classNames('min-w-0 space-y-1', { 'col-span-full': item.span === 'full' })}
        >
          <ErpSpan className="block text-xs text-muted-foreground">{item.label}</ErpSpan>
          <ErpSpan className={classNames('block min-w-0 [overflow-wrap:anywhere] text-sm leading-snug font-medium text-foreground', { 'font-mono tabular-nums': item.mono })}>
            {renderValue ? renderValue(item) : (item.value ?? '—')}
          </ErpSpan>
        </ErpDiv>
      ))}
    </ErpDiv>
  );
};

export const DetailGrid = React.memo(_DetailGrid);
